import React, { useEffect } from 'react';
import MenuOptions from './MenuOptions';
import MenuVariaveis from '../../../MenuVariaveis';
import iconPlusWhite from '../../../../assets/images/ic_plus_white.svg';
import iconAddBotao from '../../../../assets/images/add_botao.svg';
import iconDeleteRed from '../../../../assets/images/icon_delete_red.svg';

export default function Menu({
  itemData,
  handleSelectVariavel,
  currentClickItem,
  editItemDescription,
  user,
  updateMenuItem,
  addText,
  menuItemIndex,
  removeMenuItem,
  menuHighlight,
  addMenuItem,
  removeText,
  isCreating,
  connectors,
  activeCreateMenuConnection,
  doUpdateItemWithDebounce,
  handleMenuOptionHighLight,
  currentPath,
  setIsMenuContainerHighLigth,
}) {
  const handleRemoveText = (e, index) => {
    if (currentClickItem === itemData._id) {
      removeText(e, index);
    } else {
      e.preventDefault();
    }
  };

  const isHighLigth = () => {
    let finalId = null;
    if (
      itemData?.menuItems.some(({ _id }) => _id === currentPath?.from) ||
      itemData?.menuItems.some(({ _id }) =>
        menuHighlight.some(({ from }) => _id === from)
      )
    ) {
      finalId = itemData._id;
    }
    setIsMenuContainerHighLigth(finalId);
  };

  useEffect(() => {
    isHighLigth();
  }, [currentPath, menuHighlight]);

  return (
    <div className="container-out-square-text">
      <div className="container-square-text">
        {itemData.description.map((value, index) => (
          <div key={String(index)} className="form-group container-btn-remove">
            <MenuVariaveis
              onSelect={(variavel) => handleSelectVariavel(variavel, index)}
              id={`bloco-${itemData._id}`}
              buttonRight="12px"
            >
              <textarea
                className="textarea"
                id={`desc-${index}-${itemData._id}`}
                data-id={`desc-${index}-${itemData._id}`}
                value={value}
                placeholder="Descrição..."
                onChange={(e) => editItemDescription(e, index)}
                maxLength={300}
              />
            </MenuVariaveis>
            {currentClickItem === itemData._id && itemData.randomTextActive && (
              <button
                type="button"
                disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
                className="action-random-text-remove-button"
                id={`btnRemoveItem-${index}-${itemData._id}`}
                style={{
                  opacity: currentClickItem === itemData._id ? 1 : 0,
                  cursor:
                    currentClickItem === itemData._id ? 'pointer' : 'default',
                }}
                onClick={(e) => {
                  handleRemoveText(e, index);
                }}
              >
                <img src={iconDeleteRed} alt="" />
              </button>
            )}
          </div>
        ))}
      </div>

      <div className="container-square-menu">
        <div className="container-square-menu-addButton">
          {currentClickItem === itemData._id && itemData.randomTextActive && (
            <button
              type="button"
              disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
              className="action-random-text-add-button"
              onClick={addText}
            >
              <img src={iconPlusWhite} alt="" />
            </button>
          )}
        </div>

        <MenuOptions
          itemData={itemData}
          menuItemIndex={menuItemIndex}
          user={user}
          menuHighlight={menuHighlight}
          connectors={connectors}
          activeCreateMenuConnection={activeCreateMenuConnection}
          updateMenuItem={updateMenuItem}
          removeMenuItem={removeMenuItem}
          isCreating={isCreating}
          doUpdateItemWithDebounce={doUpdateItemWithDebounce}
          handleMenuOptionHighLight={handleMenuOptionHighLight}
          currentPath={currentPath}
          setIsMenuContainerHighLigth={setIsMenuContainerHighLigth}
        />

        <div className="container-block-menu-item-add">
          <button
            type="button"
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            className="block-menu-item-add"
            onClick={addMenuItem}
          >
            <img src={iconAddBotao} alt="Adicionar Opção" />
          </button>
        </div>
      </div>
    </div>
  );
}
